import React from 'react';
import Title from 'components/UI/Title';
import Checkbox from 'components/UI/Checkbox';
import * as styles from './Mobile.module.scss';

function CheckboxMobile({ name, value, onChange }) {
  return (
    <Checkbox onChange={() => onChange(name, !value)} checked={value}>
      <Title tag="h3" size={false} className={styles.fontMd}>
        {name}
      </Title>
    </Checkbox>
  );
}

export default React.memo(CheckboxMobile);
